// 🆕 [Phase 56.4a] CalendarContext — Provider + hook pour partager le state
// du composant CalendrierProduction avec ses sous-composants (notamment
// <CalendarWeekRow> à venir en 56.4b). Évite le prop drilling massif
// (~28 props si on passait tout en direct).
//
// Usage :
//   // Dans le parent
//   import { CalendarProvider } from '@/components/calendar/CalendarContext';
//   <CalendarProvider value={calendarContextValue}>...</CalendarProvider>
//
//   // Dans un descendant
//   import { useCalendar } from '@/components/calendar/CalendarContext';
//   const { bons, employees, ... } = useCalendar();
import { createContext, useContext } from 'react';

const CalendarContext = createContext(null);

export const useCalendar = () => {
  const ctx = useContext(CalendarContext);
  if (!ctx) throw new Error('useCalendar must be used within CalendarProvider');
  return ctx;
};

export const CalendarProvider = ({ value, children }) => (
  <CalendarContext.Provider value={value}>{children}</CalendarContext.Provider>
);
